import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { subscriptionEvent } from './SubscriptionBadge';

export const TrialBanner: React.FC = () => {
  const [assinatura, setAssinatura] = useState<any>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleSubscription = (e: any) => {
      setAssinatura(e.detail);
    };

    subscriptionEvent.addEventListener('subscription_loaded', handleSubscription);
    return () => {
      subscriptionEvent.removeEventListener('subscription_loaded', handleSubscription);
    };
  }, []);

  if (!assinatura) return null;

  // Soft Block: Se estiver expirado, exibe banner gigante
  if (assinatura.status_assinatura === 'expirado') {
    return (
      <div className="alert alert-danger mx-3 mt-3 shadow-sm d-flex justify-content-between align-items-center" style={{ borderLeft: '5px solid #bd2130' }}>
        <div>
          <h5 className="mb-1"><i className="fas fa-lock mr-2"></i> Período de Teste Expirado</h5>
          <p className="mb-0">
            Seu acesso agora está no <strong>Modo Somente-Leitura</strong>. Você pode visualizar seus dados, mas a criação de novos registros (como pacientes, consultas e prontuários) está bloqueada.
          </p>
        </div>
        <button 
          onClick={() => navigate('/pagamento')} 
          className="btn btn-danger font-weight-bold ml-3 px-4 py-2 shadow-sm"
        >
          Reativar Acesso
        </button>
      </div>
    );
  }

  // Aviso de urgência: Faltam 2 dias ou menos
  if (assinatura.status_assinatura === 'trial' && assinatura.dias_restantes <= 2) {
    return (
      <div className="alert alert-warning mx-3 mt-3 shadow-sm d-flex justify-content-between align-items-center" style={{ borderLeft: '5px solid #d39e00', backgroundColor: '#fff3cd', color: '#856404' }}>
        <div>
          <h5 className="mb-1"><i className="fas fa-exclamation-triangle mr-2"></i> Seu período de teste acaba em {assinatura.dias_restantes} dia(s)!</h5>
          <p className="mb-0">
            Garanta sua assinatura agora para não perder o acesso completo à plataforma e manter tudo organizado.
          </p>
        </div>
        <button 
          onClick={() => navigate('/pagamento')} 
          className="btn btn-warning font-weight-bold text-dark ml-3 px-4 py-2 shadow-sm"
        >
          Assinar Agora
        </button>
      </div>
    );
  }

  return null;
};

export default TrialBanner;
